"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBar = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const react_router_dom_1 = require("react-router-dom");
const styles_1 = require("@material-ui/core/styles");
const SimpleGrid_1 = require("../../SimpleGrid");
const useSearchBar_1 = require("../../../hooks/useSearchBar");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const HighlightOff_1 = __importDefault(require("@material-ui/icons/HighlightOff"));
const drawerWidth = 240;
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    colLeft: {
        width: drawerWidth - theme.spacing(4)
    },
    colRight: {
        width: drawerWidth - theme.spacing(4),
        textAlign: 'right'
    },
    colMiddle: {
        width: `calc(100% - ${drawerWidth}px - ${drawerWidth}px + ${theme.spacing(8)}px)`
    },
    userButton: {
        lineHeight: 0.7,
        textAlign: 'right',
        textTransform: 'initial'
    },
    searchContainer: {
        maxWidth: 600,
        textAlign: 'center',
        margin: '10px auto'
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[0],
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        userSelect: 'none'
    },
    appLogo: {
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontSize: '1.1rem'
    },
    searchButton: {
        transitionProperty: 'none'
    },
    notchedOutline: {
        borderColor: 'transparent'
    },
    rootOutline: {
        backgroundColor: '#f0f0f0'
    },
    focusedOutline: {
        backgroundColor: '#fff'
    }
}));
const DefaultBar = (props) => {
    const classes = useStyles();
    const { componentLogo, appName, appIsLoading = false, userHeadings = ['Your Profile'], userAvatar, searchBarDisabled, searchBarActiveQuery, searchBarPlaceholder, setMenuUserVisible, onSearch } = props;
    const { handleBlur, handleChange, handleEnterPress, handleFocus, handleResetClick, handleSubmitClick, value, isFocused, disabled } = useSearchBar_1.useSearchBar({
        onSearch,
        disabled: searchBarDisabled,
        activeQuery: searchBarActiveQuery
    });
    return (react_1.default.createElement(core_1.AppBar, { position: "fixed", color: "inherit", elevation: 1, className: classes.appBar },
        react_1.default.createElement(core_1.Toolbar, null,
            react_1.default.createElement("div", { className: classes.colLeft },
                react_1.default.createElement(core_1.Button, { to: "/", component: react_router_dom_1.Link }, componentLogo ? componentLogo : react_1.default.createElement("span", { className: classes.appLogo }, appName))),
            react_1.default.createElement("div", { className: classes.colMiddle }, onSearch && (react_1.default.createElement("div", { className: classes.searchContainer },
                react_1.default.createElement(core_1.TextField, { disabled: disabled, fullWidth: true, placeholder: searchBarPlaceholder, variant: "outlined", onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyPress: handleEnterPress, focused: isFocused, value: value, InputProps: {
                        classes: {
                            notchedOutline: classes.notchedOutline,
                            root: classes.rootOutline,
                            focused: classes.focusedOutline
                        },
                        startAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                            react_1.default.createElement(Search_1.default, null))),
                        endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                            isFocused && (react_1.default.createElement(core_1.Button, { disabled: disabled, color: isFocused ? 'primary' : 'default', size: "small", variant: "contained", disableElevation: true, onClick: handleSubmitClick, classes: {
                                    root: classes.searchButton
                                } }, "Search")),
                            !isFocused && searchBarActiveQuery && (react_1.default.createElement(core_1.IconButton, { onClick: handleResetClick, "aria-label": "delete" },
                                react_1.default.createElement(HighlightOff_1.default, null)))))
                    } })))),
            react_1.default.createElement("div", { className: classes.colRight },
                react_1.default.createElement(core_1.Button, { classes: { label: classes.userButton }, onClick: setMenuUserVisible },
                    react_1.default.createElement(SimpleGrid_1.SimpleGrid, { justify: "space-around", left: userHeadings.length > 1 ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(core_1.Typography, null, userHeadings[0]),
                            react_1.default.createElement(core_1.Typography, { variant: "caption", color: "textSecondary" }, userHeadings[1]))) : (react_1.default.createElement(core_1.Typography, null, userHeadings[0])), right: react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(core_1.Avatar, { src: userAvatar, style: { marginLeft: 10, width: 45, height: 45 } })) })))),
        appIsLoading && react_1.default.createElement(core_1.LinearProgress, null)));
};
exports.DefaultBar = DefaultBar;
//# sourceMappingURL=DefaultBar.js.map